export const CONTENIDO_BIBLIOTECA_ACTION_TYPES = {
    FETCH_MOSTRAR_CONTENIDO_START: "contenidoBiblioteca/FETCH_MOSTRAR_CONTENIDO_START",
};
